interface SeoStructuredDataProps {
  type: 'Organization' | 'WebSite' | 'WebPage' | 'Article' | 'FAQPage';
  pageTitle?: string;
  pageDescription?: string;
  pageUrl?: string;
  articleTitle?: string;
  articleDescription?: string;
  articleDate?: string;
  articleAuthor?: string;
  articleImage?: string;
  breadcrumbItems?: { name: string; url: string }[];
  faqItems?: { question: string; answer: string }[];
}

export default function SeoStructuredData({
  type,
  pageTitle,
  pageDescription,
  pageUrl,
  articleTitle,
  articleDescription,
  articleDate,
  articleAuthor,
  articleImage,
  breadcrumbItems,
  faqItems,
}: SeoStructuredDataProps) {
  const baseUrl = 'https://jiucao.community';

  const getStructuredData = () => {
    switch (type) {
      case 'Organization':
        return {
          '@context': 'https://schema.org',
          '@type': 'Organization',
          name: '久草社区',
          url: baseUrl,
          description: '久草社区是深受用户喜爱的在线内容聚合与互动交流平台，汇聚海量精选资源、活跃社区讨论与多元兴趣圈子。',
          logo: `${baseUrl}/logo.png`,
          contactPoint: {
            '@type': 'ContactPoint',
            contactType: 'customer service',
            email: 'contact@jiucao.community',
            availableLanguage: ['Chinese'],
          },
          sameAs: [],
        };

      case 'WebSite':
        return {
          '@context': 'https://schema.org',
          '@type': 'WebSite',
          name: '久草社区',
          url: baseUrl,
          description: '热门内容聚合与用户交流平台',
          potentialAction: {
            '@type': 'SearchAction',
            'target': {
              '@type': 'EntryPoint',
              urlTemplate: `${baseUrl}/search?q={search_term_string}`,
            },
            'query-input': 'required name=search_term_string',
          },
        };

      case 'WebPage':
        return {
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: pageTitle || '久草社区',
          description: pageDescription || '久草社区-热门内容聚合与用户交流平台',
          url: pageUrl || baseUrl,
          isPartOf: {
            '@type': 'WebSite',
            name: '久草社区',
            url: baseUrl,
          },
          ...(breadcrumbItems && {
            breadcrumb: {
              '@type': 'BreadcrumbList',
              itemListElement: breadcrumbItems.map((item, index) => ({
                '@type': 'ListItem',
                position: index + 1,
                name: item.name,
                item: item.url,
              })),
            },
          }),
        };

      case 'Article':
        return {
          '@context': 'https://schema.org',
          '@type': 'Article',
          headline: articleTitle,
          description: articleDescription,
          image: articleImage,
          datePublished: articleDate,
          author: {
            '@type': 'Person',
            name: articleAuthor,
          },
          publisher: {
            '@type': 'Organization',
            name: '久草社区',
          },
          mainEntityOfPage: {
            '@type': 'WebPage',
            '@id': pageUrl || baseUrl,
          },
        };

      case 'FAQPage':
        return {
          '@context': 'https://schema.org',
          '@type': 'FAQPage',
          mainEntity: (faqItems || []).map((item) => ({
            '@type': 'Question',
            name: item.question,
            acceptedAnswer: {
              '@type': 'Answer',
              text: item.answer,
            },
          })),
        };

      default:
        return null;
    }
  };

  const data = getStructuredData();
  if (!data) return null;

  return (
    <script type="application/ld+json">
      {JSON.stringify(data)}
    </script>
  );
}